import React from "react";
import PropTypes from "prop-types";
import styles from "./UserColumnFilters.module.css";

/**
 * UserColumnFilters - Component for filtering table columns
 *
 * @param {Object} props - Component props
 * @param {string} props.column - The current column being filtered
 * @param {Object} props.filters - Current filter values for columns
 * @param {Function} props.onFilterChange - Callback when a filter changes
 * @param {Function} props.onToggleFilterDropdown - Toggle filter dropdown visibility
 * @param {string} props.activeFilter - Currently active filter column
 * @param {Array} props.uniqueValues - Array of unique values for the current column
 */
const UserColumnFilters = ({
  column,
  filters,
  onFilterChange,
  onToggleFilterDropdown,
  activeFilter,
  uniqueValues = [],
}) => {
  const isActive = column === activeFilter;
  const hasActiveFilter = filters[column] !== undefined;

  return (
    <span className={styles.columnFilterContainer}>
      <span
        className={styles.columnFilterIcon}
        onClick={() => onToggleFilterDropdown(column)}
      >
        🔍
        {hasActiveFilter && <span className={styles.filterActive}>●</span>}
      </span>

      {isActive && (
        <div className={styles.filterDropdown}>
          <div className={styles.filterDropdownHeader}>
            <span>Filter by {column}</span>
            <button onClick={() => onToggleFilterDropdown(null)}>✕</button>
          </div>

          <div className={styles.filterDropdownOptions}>
            {uniqueValues.map((value) => (
              <div
                key={value}
                className={`${styles.filterOption} ${
                  filters[column] === value ? styles.selected : ""
                }`}
                onClick={() => onFilterChange(column, value)}
              >
                {value === "all"
                  ? "Show All"
                  : value === "empty"
                  ? "(Empty)"
                  : value}
              </div>
            ))}
          </div>
        </div>
      )}
    </span>
  );
};

UserColumnFilters.propTypes = {
  column: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onToggleFilterDropdown: PropTypes.func.isRequired,
  activeFilter: PropTypes.string,
  uniqueValues: PropTypes.array,
};

UserColumnFilters.defaultProps = {
  filters: {},
  uniqueValues: ["all", "empty"],
};

export default UserColumnFilters;
